import React from "react";
import { MDBCol, MDBFormInline, MDBIcon } from "mdbreact";

const SearchPage = () => {
  return (
    <>
    <style>
      {`
        .search-btn:hover {
          background-color: transparent;
        }
      `}
    </style>
    <MDBCol>
      <MDBFormInline className="md-form" action="/search" method="GET">
        <input
          className="form-control form-control-sm ml-3 w-100"
          type="text"
          placeholder="Search"
          aria-label="Search"
          name="t"
        />
        <button className="bg-none p-0 search-btn">
          <MDBIcon icon="search" />
        </button>
      </MDBFormInline>
    </MDBCol>
    </>
  );
};

export default SearchPage;
